import styled from 'styled-components';

export const FooterContainer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 90px;
  background-color: ${({ theme: { token } }) => token.colorBgElevated};
  box-shadow: 0px -4px 16px 0px rgba(0, 0, 0, 0.15);
  padding: ${({ theme: { token } }) => token.paddingLG}px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .flex-row-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${({ theme: { token } }) => token.margin}px;
  }

  .color-success {
    background: ${({ theme: { token } }) => token.colorSuccess};
    &:hover {
      background: ${({ theme: { token } }) => token.colorSuccessHover} !important;
    }
  }

  .hidden {
    visibility: hidden;
  }
`;
